import React from "react";
import ReactDOM from "react-dom/client";
import App from "@/App";
import "@/index.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

/**
 * Registering the service worker is what makes the hub installable as a desktop
 * app. Service workers only run in a secure context, which means localhost or
 * HTTPS — over plain HTTP by IP or hostname this quietly does nothing, and the
 * app still works as a normal page.
 */
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((err) => {
      console.info("Service worker not registered:", err.message);
    });
  });
}
